module.exports = __webpack_public_path__ + "static/media/bond.d580dabf.svg";